import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NewParcourCertificate } from 'src/app/model/NewParcourCertificate';
import { Route, Router } from '@angular/router';
import { BreadcrumbItem } from 'src/app/modules/shared/components/breadcrumb/breadcrumb.component';
import { CohortesParcours } from 'src/app/model/cohorte-parcours.model';
import { AppelsService } from 'src/app/modules/appels/service/appels.service';
import { MentoratService } from '../../services/mentorat.service';
import { catchError, of, tap } from 'rxjs';
import { CertificatesMentorat } from 'src/app/model/certificates-mentorat.model';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { em } from '@fullcalendar/core/internal-common';

@Component({
  selector: 'app-form-new-certificate-mentorat',
  templateUrl: './form-certificate-mentorat.component.html',
  styleUrls: ['./form-certificate-mentorat.component.css'],
})
export class FormNewCertificateMentoratComponent {
  mentoratCertificateForm!: FormGroup;
  //hpcertificateForm!: FormGroup;

  valid!: boolean;
  inValid!: boolean;
  error!: boolean;

  inValidId!: boolean;
  inValidName!: boolean;
  inValidShort!: boolean;
  //inValidStartdate!: boolean;
  //inValidEnddate!: boolean;
  //inValidAppeldate!: boolean;
  //urlCertificat!: boolean;
  invalidCertificateCode!: boolean;
  invalidFullname!: boolean;
  invalidPlatforme!: boolean;
  //invalidCategorie!: boolean;
  //invalidUrl!: boolean;
  invalidDescription!: boolean;

  platforms: string[] = ['Moodle', 'Coursera'];
  categorys!: any[];

  user: any;
  currentUserEmail!: string;

  constructor(
    private mentoratService: MentoratService,
    private appelService: AppelsService,
    private authService: AuthService,
    private fb: FormBuilder,
    private router: Router,
  ) {
    this.user = sessionStorage.getItem('user');
    this.currentUserEmail = JSON.parse(this.user).email;
  }

  ngOnInit(): void {
    this.initializeForm();
    this.loadCategorys();
    this.setUpFormValidation();
  }

  initializeForm() {
    this.mentoratCertificateForm = this.fb.group({
      //id: ['', Validators.required],
      name: ['', Validators.required],
      shortname: ['', Validators.required],
      fullname: ['', Validators.required],
      certificateCode: ['', Validators.required],
      plateforme: ['', Validators.required],
      description: ['', Validators.required],
      //createdBy: ['', Validators.required],
    });
  }

  setUpFormValidation() {
    this.mentoratCertificateForm.get('id')?.valueChanges.subscribe((values) => {
      if (values.length > 0) {
        this.inValidId = false;
      }
    });
    this.mentoratCertificateForm
      .get('name')
      ?.valueChanges.subscribe((values) => {
        if (values.length > 0) {
          this.inValidName = false;
        }
      });
    this.mentoratCertificateForm
      .get('shortname')
      ?.valueChanges.subscribe((values) => {
        if (values.length > 0) {
          this.inValidShort = false;
        }
      });
    this.mentoratCertificateForm
      .get('fullname')
      ?.valueChanges.subscribe((values) => {
        if (values.length > 0) {
          this.invalidFullname = false;
        }
      });
    this.mentoratCertificateForm
      .get('certificateCode')
      ?.valueChanges.subscribe((values) => {
        if (values.length > 0) {
          this.invalidCertificateCode = false;
        }
      });
    this.mentoratCertificateForm
      .get('plateforme')
      ?.valueChanges.subscribe((values) => {
        if (values.length > 0) {
          this.invalidPlatforme = false;
        }
      });
    this.mentoratCertificateForm
      .get('description')
      ?.valueChanges.subscribe((values) => {
        if (values.length > 0) {
          this.invalidDescription = false;
        }
      });
  }

  loadCategorys() {
    this.appelService
      .listCategory()
      .pipe()
      .subscribe({
        next: (response) => {
          this.categorys = response;
        },
        error: (err) => {},
      });
  }

  createMentoratCertificate() {
    if (this.mentoratCertificateForm.valid) {
      this.submitValidForm();
    } else {
      this.handleInvalidForm();
    }
  }

  private submitValidForm() {
    const formValue = this.mentoratCertificateForm.value;
    const certificatesMentorat = new CertificatesMentorat(
      formValue['name'],
      formValue['shortname'],
      formValue['fullname'],
      formValue['certificateCode'],
      formValue['plateforme'],
      formValue['description'],
    );
    certificatesMentorat.createdBy = this.currentUserEmail;
    this.mentoratService
      .createMentoratCertificate(certificatesMentorat)
      .pipe(
        tap((response) => {
          console.log('Response from createMentoratCertificate:', response);

          if (response && response.status === 201) {
            this.handleSuccess();
          } else {
            this.handleError();
          }
        }),
        catchError((error) => {
          console.error('Erreur lors de la création du certificat:', error);
          this.handleError();
          return of(null);
        }),
      )
      .subscribe();
  }

  private handleInvalidForm() {
    window.scrollTo(0, 0);
    this.inValid = true;
    setTimeout(() => {
      this.inValid = false;
    }, 3000);
    const formValue = this.mentoratCertificateForm.value;
    this.inValidName = !formValue['name'];
    this.inValidShort = !formValue['shortname'];
    this.invalidPlatforme = !formValue['plateforme'];
    this.invalidFullname = !formValue['fullname'];
    this.invalidDescription = !formValue['description'];
  }

  private handleSuccess() {
    window.scrollTo(0, 0);
    this.mentoratCertificateForm.reset();
    this.valid = true;
    setTimeout(() => {
      this.valid = false;
      this.router.navigate(['/dashboard/appels/sigui-certificat']);
    }, 5000);
  }

  private handleError() {
    window.scrollTo(0, 0);
    this.error = true;
    setTimeout(() => {
      this.error = false;
    }, 5000);
  }

  resetCreation() {
    this.mentoratCertificateForm.reset();
    window.scrollTo(0, 0);
  }

  createCohorte(dateAppel: string): string {
    const date = dateAppel.toString().substring(2, 7).replace('-', '');

    const cohorteHorsParcours = 'HSIG' + date + '-FODE';
    return cohorteHorsParcours;
  }

  breadcrumbItems: BreadcrumbItem[] = [
    { label: 'SIGUI' },
    {
      label: 'GESTION DES CERTIFICATS',
      url: '/dashboard/appels/sigui-certificat',
    },
    {
      label: 'AJOUTER UN NOUVEAU CERTIFICAT MENTORAT',
      url: '/dashboard/appels/new-mentorat-certificat',
    },
  ];
}
